// Device-tier detection for graduated perf strategies.
//
// Two tiers feed `.perf-{tier}` on <html>:
//   - 'low'  — Fire tablets, Android 6-7, Chrome 4x/5x WebViews, any device
//              with deviceMemory ≤ 4GB or ≤ 4 cores, or user prefers reduced
//              motion. These get the heaviest CSS effects stripped.
//   - 'high' — everything else (modern phones/tablets/desktop).
//
// The result drives which expensive CSS effects mount. Users can override the
// outcome by choosing an explicit performance mode in Settings (see
// AnimationContext) — this module only handles the automatic ("Auto") path.

// Matches Fire tablets ("Silk" browser id), Android 6/7, and Chrome 4x-5x.
const LOW_END_UA = /Silk|Android [67]\.|Chrome\/(4\d|5[0-3])\./;

export function detectDeviceTier() {
  if (typeof navigator === 'undefined') return 'high';

  const ua = navigator.userAgent || '';
  const memory = typeof navigator.deviceMemory === 'number' ? navigator.deviceMemory : null;
  const cores = typeof navigator.hardwareConcurrency === 'number' ? navigator.hardwareConcurrency : null;

  let prefersReduced = false;
  try {
    prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch {}

  let tier;
  // Low signals: known low-end UA, ≤4GB RAM, ≤4 cores, or OS-level motion pref.
  if (LOW_END_UA.test(ua)) tier = 'low';
  else if (memory !== null && memory <= 4) tier = 'low';
  else if (cores !== null && cores <= 4) tier = 'low';
  else if (prefersReduced) tier = 'low';
  else tier = 'high';

  // One-shot diagnostic so field traces can confirm what the auto-detect
  // actually returned without needing chrome://inspect.
  try {
    // eslint-disable-next-line no-console
    console.info(`[deviceTier] tier=${tier} memory=${memory} cores=${cores} prefersReduced=${prefersReduced} ua="${ua.slice(0, 120)}"`);
  } catch {}

  return tier;
}
